"use strict"
<template>
  <form v-on:submit.prevent="sendRequest(0,'student_profiles')" id="filters">
    <div class="row col-xs-12 col-sm-6 col-md-6">
      <div  class="filter-item">
        <h4>Aufnahme:</h4>
        <div class="row">
          <div class="col-md-12 col-sm-6 col-xs-12" 
          v-for="hosting_time in filters.hosting_times" v-bind:key="hosting_time">
            <input v-bind:disabled="update.spinner" 
            v-model="searchRequest.hosting_times" 
            v-bind:value="hosting_time" type="checkbox" 
            v-bind:id="hosting_time" @click="getFilters(searchRequest)" 
            />
            <span class="hosting_time" v-if="hosting_time === 'hosting_now'">
              <label v-bind:for="hosting_time">
                ab sofort
              </label>
            </span>
            <span class="hosting_time" v-else-if="hosting_time === 'summer_season'">
              <label v-bind:for="hosting_time">
                ab Sommer
              </label>
            </span>
            <span class="hosting_time" v-else>
              <label v-bind:for="hosting_time">
                ab Winter
              </label>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="row col-xs-12 col-sm-6 col-md-6">
      <div class="filter-item">
        <h4>Alter:</h4>
        <div class="row">
          <div class="col-md-12 col-sm-6 col-xs-12" v-for="age in filters.ages" v-bind:key="age">
            <input v-bind:disabled="update.spinner" v-model="searchRequest.age" v-bind:value="age" type="checkbox" v-bind:id="age" @click="getFilters(searchRequest)"/>
            <label v-bind:for="age" > {{age + " Jahre"}}</label>
          </div>
        </div>
      </div>
    </div>
    <div class="row col-xs-12 col-sm-6 col-md-6">
      <div class="filter-item">
        <h4>Geschlecht:</h4>
          <div class="row">
            <div class=" col-md-12 col-sm-12 col-xs-6" v-for="gender in filters.genders" :key="gender">
              <input v-bind:disabled="update.spinner" v-model="searchRequest.gender" v-bind:checked="getFilters(searchRequest)"  v-bind:value="gender" type="checkbox" :id="gender"/>
              <span class="gender" v-if="gender == 'm'">
                <label v-bind:for="gender"><i class="fa fa-male"></i></label></span>
              <span class="gender" v-else>
                <label v-bind:for="gender"><i class="fa fa-female"></i></label>
              </span>
            </div>
        </div>
      </div>
    </div>
    <br>
      <h4>Freie Stichwortsuche, z.B. nach Sportarten, Musikinstrumenten, Interessen etc.:</h4>
      <br>
      <div class="row">
        <div class="col-xs-8 col-sm-8 col-md-7">
          <v-select v-bind:disabled="update.spinner" max-height="200px" multiple @="getFilters(searchRequest)" label="name" value="text" v-model="selectedHobbies" v-bind:options="hobbies" v-bind:placeholder="update.spinner ? 'Bitte warten...' : 'Suchen'"></v-select>
        </div>
        <div class="col-md-5 col-sm-4 col-xs-4">
          <button class="nomargin host-btn" v-bind:disabled="update.spinner">
            <h5 class="filtertext">{{update.spinner ? 'Filtern' : 'Filtern'}}</h5>
            <span class="btn-arrow"><i aria-hidden="true" class="fa fa-chevron-right"></i></span>
          </button>
        </div>
      </div>
  </form>
</template>

<script>
export default {
  props: ['filters', 'loadLimit','students', 'counter', 'hobbies','update', 'Params','studentscount'],
  data(){
    return{
     selectedHobbies:[],
     searchRequest:{
        hosting_times:[],
        gender:[],
        age: [],
        hobby:[],
      },
      disableApplyTimes: false
    }
  },
  components: {
    "v-select": () => import('vue-select')
  },
  watch:{
    selectedHobbies: function () {
      var self = this;
      //push id to searchRequest.hoddy
      self.searchRequest.hobby = self.selectedHobbies.map(function(a){
        return a.id;
      });
      self.$parent.getDatasAsUriParameters(self.searchRequest);
    }
  },
  methods:{
    resetCheckboxApplyTimes($event) {
      var self = this;
      self.searchRequest.hosting_times = [];
      if ($event.target.checked) this.searchRequest.hosting_times.push($event.target.value);
    },
    getFilters: function (obj) {
      var self = this;
      self.$parent.getDatasAsUriParameters(obj);
    },
    sendRequest: function(counter,url) {
      var self = this;
      self.$parent.counter = 0;
      self.$parent.students = [];
      self.update.spinner = true;
      self.$parent.getData(counter,url);
      //find student first selector
      // self.$el.scrollIntoView({
      //   behavior: "smooth",
      //   block: "center",
      //   inline: "center"
      // });
    }
  }
};
</script>
